import { axiosRequest } from "../../../../service";
import { HEALTH_CALCULATION_SERVICE, HEALTH_PAYMENT_SERVICE, REACT_APP_VAM_ENDPOINT } from "../../../../urls";

export const getCalculatePayout = async (payload , setLoading) => {
  try {
    setLoading(true);
    const response = await axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${HEALTH_CALCULATION_SERVICE}/calculate`,payload);
    return response;
  } catch (error) {
    setLoading(false);
    console.error("Error while getting basic search results:", error);
    throw error;
  }
};

export const updateCalculationHandlers = async (payload , setLoading) => {
  try {
    setLoading(true);
    const response = await axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${HEALTH_CALCULATION_SERVICE}/update-calculation`,payload);
    return response;
  } catch (error) {
    setLoading(false);
    console.error("Error while getting basic search results:", error);
    throw error;
  }
};
export const getCalculationHistory = async (claimId , setLoading) => {
  try {
    setLoading(true);
    const response = await axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${HEALTH_CALCULATION_SERVICE}/calc-history/${claimId}`)
    return response;
  } catch (error) {
    setLoading(false);
    console.error("Error while getting basic search results:", error);
    throw error;
  }
};
export const getPaymentHistory = async (claimId , setLoading) => {
  try {
    setLoading(true);
    const response = await axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${HEALTH_PAYMENT_SERVICE}/payment-history/${claimId}`)
    return response;
  } catch (error) {
    setLoading(false);
    console.error("Error while getting basic search results:", error);
    throw error;
  }
};
export const getBankDetailsHistory = async (claimId ,paymentID, setLoading) => {
  try {
    setLoading(true);
    const response = await axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${HEALTH_PAYMENT_SERVICE}/payout-details?paymentId=${paymentID}&claimId=${claimId}&lineOfBusiness=2`)
    return response;
  } catch (error) {
    setLoading(false);
    console.error("Error while getting basic search results:", error);
    throw error;
  }
};
export const updatePayout = async (payload, setLoading) => {
  try {
    setLoading(true);
    const response = await axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${HEALTH_PAYMENT_SERVICE}/modify-payout`, payload)
    return response;
  } catch (error) {
    setLoading(false);
    console.error("Error while getting basic search results:", error);
    throw error;
  }
};

